/** WorkspaceMonogram — colored initials tile derived from display_name. */
import type { Workspace } from "@/entities/workspace/model";

interface Props {
  workspace: Workspace | null;
  size?: "sm" | "md" | "lg";
  className?: string;
}

function monogram(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return "•";
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

const SIZE_CLASSES: Record<Required<Props>["size"], string> = {
  sm: "h-7 w-7 text-[10px]",
  md: "h-9 w-9 text-xs",
  lg: "h-14 w-14 text-lg",
};

export function WorkspaceMonogram({ workspace, size = "md", className = "" }: Props): JSX.Element {
  const letters = workspace ? monogram(workspace.profile.display_name) : "··";
  const bg = workspace?.profile.primary_color ?? "#334155";
  return (
    <span
      data-testid="workspace-monogram"
      aria-hidden
      className={`grid place-items-center rounded-md font-mono font-semibold text-white shadow-sm ${SIZE_CLASSES[size]} ${className}`}
      style={{ backgroundColor: bg }}
    >
      {letters}
    </span>
  );
}
